'use strict';
(function(angular) {
  angular.module('fetchtv.Directives')
    .directive('ftBinCheck', function($q, binDbService) {
      return {
        require: 'ngModel',
        link: function(scope, elm, attrs, ctrl) {
          ctrl.$asyncValidators.ft_bin_check = function(modelValue) {
            if (ctrl.$isEmpty(modelValue)) {
              // consider empty model valid
              return $q.resolve();
            }
            return binDbService.checkBin({
              bin: modelValue.substring(0, 6),
              allowedCountries: ['AU']
            });
          };
        }
      };
    });
})(angular);

